module.exports = __webpack_public_path__ + "static/img/home_artificial_intelligence.3dfd280.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/home_artificial_intelligence.png
// module id = 1396
// module chunks = 1